<template>
  <div
    v-if="detailLinkIsURL || (townUrl && isMobile)"
    class="d-flex flex-column ga-2 align-center"
  >
    <template v-if="isMobile">
      <v-btn
        v-if="detailLinkIsURL"
        :color="townUrl ? 'primary' : 'bg-primary'"
        :href="detailAppointmentLink"
        class="w-100"
        depressed
        @click="handleClickDetailButton"
      >
        <span :class="{ 'primary--text': !townUrl }">Детали записи</span>
      </v-btn>
      <v-btn
        v-if="townUrl"
        :color="detailLinkIsURL ? 'bg-primary' : 'primary'"
        :href="townUrl"
        class="w-100"
        depressed
      >
        <span :class="{ 'primary--text': detailLinkIsURL }">На главную</span>
      </v-btn>
    </template>
    <v-btn
      v-else
      color="bg-primary"
      :href="detailAppointmentLink"
      depressed
      @click="handleClickDetailButton"
    >
      <span class="primary--text">Детали записи</span>
    </v-btn>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import YandexGoals from 'www/modules/YandexGoals'
import { APPOINTMENT_YANDEX_GOALS } from 'src/components/pages/appointment/vrach/new/constants'

const props = defineProps<{
  townUrl?: string
  detailAppointmentLink?: string
}>()

type Emits = {
  (_event: 'club:redirect-to-medtochka'): void
}

const emit = defineEmits<Emits>()

const isMobile = window.MOBILE_VERSION

const yandexGoalsInstance = new YandexGoals()
const detailLinkIsURL = computed(() => {
  if (!props.detailAppointmentLink) {
    return
  }

  return props.detailAppointmentLink.indexOf('http') !== -1
    && props.detailAppointmentLink.length > 5
})

function handleClickDetailButton() {
  yandexGoalsInstance.send({ name: APPOINTMENT_YANDEX_GOALS.clickRedirectToMedtochka })
  emit('club:redirect-to-medtochka')
}
</script>
